const loadSmartCommDraftEditorApi = (baseUrl: string, callback: () => void) => {
  const id = 'smartCommDraftEditorApi';
  const existingScript = document.getElementById(id);

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `${baseUrl}/one/draft-editor/lib/draft-editor-api.js`;
    script.id = id;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  }

  if (existingScript && callback) {
    callback();
  }

  return () => {
    document.getElementById(id)?.remove();
  };
};

export default loadSmartCommDraftEditorApi;
